import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useHistory } from 'react-router-dom';
import UserContext from 'Shared/UserContext';
import { resetLogin } from 'Shared/UserContext/Actions';
import {
  Badge,
  Box,
  CardMedia,
  ClickAwayListener,
  Divider,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip,
} from '@mui/material';
import ReferencialContext, {
  setSelectedBrand,
  setSelectedFamily,
  setSelectedProduct,
} from 'Shared/ReferencialContext';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import NotificationsIcon from 'Images/notification.svg';
import { defaultMessage } from 'Shared/Referencial/ReferencialService';
import { toast } from 'react-toastify';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DifferenceOutlinedIcon from '@mui/icons-material/DifferenceOutlined';
import { useDispatch } from 'react-redux';
import { setOpenTrace, setuserRole } from 'Components/Traceability/traceabilitySlice';
import { setClientInfo } from 'Components/Recovery/RecoveryView/clientInfoSlice';
import Alert from './alert.png';
import { getNotifications, MarkAllNotificationsRead } from './HeaderService';
import ProductSearch from './ProductSearch';
import useStyles from './constants';

const mapRole = (role) => {
  switch (role) {
    case 'ROLE_DISPATCHER':
      return 'dispatcher';
    case 'ROLE_ADMIN':
      return 'admin';
    case 'ROLE_LIAISON':
      return 'liaison';
    case 'BUYER':
      return 'Achat';
    case 'BUYER_MANAGER':
      return 'Achat manager';
    default:
      return role;
  }
};

const Header = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatchSlice = useDispatch();
  const {
    dispatch: dispatchRef,
    state: { referencial },
  } = useContext(ReferencialContext);
  const [catalog, setCatalog] = useState([]);
  const [search, setSearch] = useState();
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = async () => {
    setOpen((prevOpen) => !prevOpen);
    if (!open) {
      try {
        await MarkAllNotificationsRead();
      } catch (e) {
        const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
        toast.error(statusLabel);
      }
    }
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);
  const {
    dispatch,
    state: { user },
  } = useContext(UserContext);
  const dispatchRedux = useDispatch();
  const handleInputChange = (event, value) => {
    setSearch(value);
    if (value) {
      if (value.reference) {
        dispatchRef(setSelectedProduct(value));
      } else if (value.familyLevel) {
        dispatchRef(setSelectedFamily(value));
        history.push('/catalog');
      } else {
        dispatchRef(setSelectedBrand(value));
        history.push('/catalog');
      }
    }
  };
  const logout = () => {
    dispatch(resetLogin());
    history.push('/login');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };
  const getNotificationList = useCallback(async () => {
    try {
      setLoading(false);
      const data = await getNotifications();
      setNotifications(data);
    } catch (e) {
      const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
      toast.error(statusLabel);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    getNotificationList();
  }, []);
  useEffect(() => {
    const { products = [], families = [], brands = [] } = referencial;
    setCatalog([
      ...products.filter((p) => p.iA),
      ...families,
      ...brands.filter((brand) => products.map((po) => po.bId).includes(brand.id)),
    ]);
  }, [referencial, setCatalog]);
  const handleClick = (notif) => (event) => {
    if (notif.type?.toUpperCase() === 'CLIENTNOTE') {
      const codes = notif.type_id.split('_');
      const noteId = codes[1];
      const clientCode = codes[3];
      dispatchRedux(setClientInfo({ isOpen: true, clientCode, noteId }));
    } else {
      dispatchRef(setSelectedProduct(notif.type_id));
    }
    handleClose(event);
  };
  const onOpenTraceability = () => {
    dispatchSlice(setOpenTrace());
    dispatchSlice(setuserRole(user.role));
  };
  return (
    <div className={classes.root}>
      {loading && <GlobalLoader size="100vh" />}
      <Box position="static" elevation={0} className={classes.AppBar}>
        <Toolbar className={classes.AppBar}>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              columnGap: 20,
            }}
          >
            <ProductSearch
              catalog={catalog}
              search={search}
              handleInputChange={handleInputChange}
            />

            {['IMPORTER', 'BUYER', 'BUYER_MANAGER', 'SAV'].includes(user.role) ? (
              <IconButton
                color="primary"
                aria-label="Traçabilités"
                style={{
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  boxShadow: '0 12px 26px #0000000D',
                  borderRadius: 12,
                  opacity: 1,
                }}
                onClick={onOpenTraceability}
              >
                <Tooltip title="Traçabilités">
                  <DifferenceOutlinedIcon color="#007BC6" />
                </Tooltip>
              </IconButton>
            ) : null }
            <IconButton
              color="primary"
              aria-label="notification"
              component="span"
              ref={anchorRef}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              style={{
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                boxShadow: '0 12px 26px #0000000D',
                borderRadius: 12,
                opacity: 1,
              }}
              size="large"
            >
              <Badge
                badgeContent={notifications.filter((n) => !n?.status).length}
                classes={{ badge: classes.badge }}
              >
                <CardMedia
                  component="img"
                  src={NotificationsIcon}
                  style={{ width: 18, height: 20 }}
                />
              </Badge>
            </IconButton>
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
              placement="bottom-start"
              style={{ zIndex: 100, height: 100, width: 400 }}
            >
              {({ TransitionProps, placement }) => (
                <Box
                  style={{
                    zIndex: 100,
                    position: 'absolute',
                    width: 400,
                    left: '11px',
                    top: '20px',
                    transformOrigin: placement === 'bottom' ? 'left top' : 'left bottom',
                    overflow: 'visible',
                  }}
                >
                  <Box style={{ position: 'relative' }}>
                    <Box
                      style={{
                        position: 'absolute',
                        width: 0,
                        height: 0,
                        borderLeft: '15px solid transparent',
                        borderRight: '15px solid transparent',
                        borderBottom: '21px solid white',
                        top: '-20px',
                        right: '20px',
                        zIndex: 999,
                      }}
                    />
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin: placement === 'bottom' ? 'right top' : 'right bottom',
                        height: 500,
                        overflowY: 'auto',
                      }}
                    >
                      <Paper style={{ padding: '30px 20px 15px' }}>
                        <Typography
                          style={{
                            textAlign: 'left',
                            font: 'normal normal 600 24px/29px Montserrat',
                            letterSpacing: 0,
                            color: '#000000',
                            opacity: 1,
                          }}
                        >
                          Notifications
                        </Typography>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList
                            autoFocusItem={open}
                            id="menu-list-grow"
                            onKeyDown={handleListKeyDown}
                          >
                            {notifications.map((n) => (
                              <MenuItem
                                key={n.notif_id}
                                onClick={handleClick(n)}
                                style={{
                                  height: 80,
                                  // background: n.status ? '#FFFFFF' : '#FA8072',
                                  // color: n.status ? '#000000' : '#FFFFFF',
                                  opacity: n.status ? 0.5 : 1,
                                  alignItems: 'flex-start',
                                  columnGap: 5,
                                }}
                              >
                                <img src={Alert} alt="alert" />
                                <Box style={{ width: '100%' }}>
                                  <Box style={{ display: 'flex', width: '100%' }}>
                                    <Typography
                                      style={{
                                        whiteSpace: 'pre-line',
                                        textAlign: 'start',
                                        font: 'normal normal 600 12px/15px Montserrat',
                                        letterSpacing: 0,
                                        color: '#707070',
                                        flexGrow: 1,
                                      }}
                                      variant="subtitle2"
                                    >
                                      {n.created_on}
                                    </Typography>
                                    {!n.status && (
                                      <FiberManualRecordIcon
                                        size="small"
                                        style={{ color: '#007BC6', fontSize: 15 }}
                                      />
                                    )}
                                  </Box>
                                  <Box
                                    style={{
                                      whiteSpace: 'pre-line',
                                      letterSpacing: 0,
                                      color: '#38485C',
                                      font: 'normal normal 500 16px/22px Montserrat',
                                    }}
                                    variant="subtitle1"
                                  >
                                    {n.message}
                                  </Box>
                                </Box>
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  </Box>
                </Box>
              )}
            </Popper>
            <Divider orientation="vertical" style={{ height: 30 }} />
            <Box style={{ display: 'flex', columnGap: 20, alignItems: 'center' }}>
              <Box
                style={{
                  background: '#007BC6 0% 0% no-repeat padding-box',
                  opacity: 1,
                  height: 52,
                  width: 52,
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexShrink: 0,
                }}
              >
                <PersonOutlineIcon style={{ color: '#FFF' }} />
              </Box>
              <Box style={{ display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
                <Typography
                  style={{
                    font: 'normal normal 400 18px Montserrat',
                    color: '#000000',
                    opacity: 1,
                    textTransform: 'capitalize',
                  }}
                >
                  {user.username?.toLowerCase()}
                </Typography>
                <Typography
                  style={{
                    font: 'normal normal 400 14px Montserrat',
                    color: '#007BC6',
                    opacity: 1,
                    textTransform: 'capitalize',
                  }}
                >
                  {`${mapRole(user.role)?.toLowerCase()} - ${
                    user?.affectation === 'Bouskoura' ? 'BO' : 'DO'
                  }`}
                </Typography>
              </Box>
            </Box>
            {false && (
              <Grid item xs={4} container direction="row-reverse">
                <div style={{ width: '100%', height: 62 }}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-end"
                    alignContent="center"
                    style={{ height: '100%' }}
                  >
                    <Grid item style={{ margin: '0 15px' }}>
                      <AccountCircle />
                    </Grid>
                    <Grid item style={{ margin: '0 15px' }}>
                      <Typography variant="body1">{user.username}</Typography>
                      <Typography variant="body2" className={classes.profile}>
                        {`${mapRole(user.role)}`}
                      </Typography>
                    </Grid>
                    <Grid item style={{ margin: '0 15px' }}>
                      <Typography variant="body1" display="block">
                        {user.affectation}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <IconButton color="inherit" onClick={logout} style={{ padding: 0 }} size="large">
                        <ExitToAppIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            )}
          </Box>
        </Toolbar>
      </Box>
    </div>
  );
};

Header.propTypes = {};

export default Header;
